import { useQuery } from '@tanstack/react-query';
import { getActiveImportById } from 'config/requests/bankOperations';
import { PENDING_STATUSES } from 'shared/widgets/RequestsBankOpsImport/constants/importFileStatuses';
import { ACTIVE_IMPORT_ID_KEY } from 'shared/widgets/RequestsBankOpsImport/hooks/useGetActiveImportId';
import { ImportFileStatusesValue } from 'types/embedded/bankOperation';
import { getLastUrlSegment } from 'utils/getLastUrlSegment';

const REFETCH_INTERVAL = 5000;

export const useGetActiveImportById = (id: string | undefined) => {
  const { data, isLoading } = useQuery({
    queryKey: [ACTIVE_IMPORT_ID_KEY, id],
    queryFn: () => getActiveImportById(id!),
    refetchInterval: (query) => {
      const status = getLastUrlSegment(query.state.data?.status) as ImportFileStatusesValue;
      return PENDING_STATUSES.includes(status) ? REFETCH_INTERVAL : false;
    },
    enabled: Boolean(id),
  });

  return { data, isLoading };
};
